import { getJsDateFromExcel } from "excel-date-to-js";
import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";
import {
    setActivePage,
    setActiveRipple,
    setChatRippleMsg,
    setCollabInfo,
    setPageType,
    setAlertData,
    setAlertManager,
    setAlertsWidget,
    setWorkspaceManager,
} from "../../../actions";
import { setChipArray } from "../../../actions/Rippleaction";
import Ripple from "../../../bae-client/Ripple";
import RippleManager from "../../../bae-client/RippleManager";
import AlertDialog from "../../stylized/AlertDialog";
import ChipsView from "../../stylized/ChipsView";
import DocViwer from "../../stylized/DocViwer";
import Loader from "../../stylized/Loader";
import ModalView from "../../stylized/ModalView";
import DocumentViewerModal from "../../stylized/DocumentViewerModal";
import RippleLogTableView from "../../stylized/RippleLogTableView";
import RippleLogView from "../../stylized/RippleLogView";
import EditRippleNameModal from "./ContentPane/RippleLog/EditRippleNameModal";
import RecureModalView from "./ContentPane/RippleLog/RecureModalView";
import "./ContentPane/RippleLog/RippleLog.css";
import RippleLogHeaderView from "./ContentPane/RippleLog/RippleLogHeaderView";
import RippleLogLinkModal from "./ContentPane/RippleLog/RippleLogLinkModal";
import RippleLogLinkToSpaceModal from "./ContentPane/RippleLog/RippleLogLinkToSpaceModal";
import RippleLogShareModal from "./ContentPane/RippleLog/RippleLogShareModal";
import TitleBar from "./TiltleBar";
import EmptyRipple from "../../stylized/EmptyRipple";
import http from "../../../bae-client/HTTP";
import * as Mixpanel from "../../../mix-panel/Mixpanel";

class RippleLog extends Component {
    constructor(props) {
        super(props);
        this.basePathName = window.runtimeConfig.instanceName;
        this.state = {
            showViewModal: false,
            showLinkToAlertModal: false,
            showLinkToSpaceModal: false,
            showRecureModal: false,
            showShareModal: false,
            showDocModal: false,
            showHistory: false,
            showRippleNameModal: false,
            currentShowFileName: "",
            currentShowFileLocation: "",
            showLoder: false,
            selectedRowIndex: -1,
            chipsArray: [],
            logRowsData: [],
            isRowSelected: false,
            sortBy: "descending",
            sortedByDate: "createdOn",
            showAlertDialog: false,
            alertDialogTitle: "",
            alertDialogMessage: "",
            isAlert: false,
            redirectToRipple: false,
        };
        this.viewModalData = [];
        this.chipsArray = [
            {
                key: 0,
                label: "java",
            },
            {
                key: 1,
                label: "Angular",
            },
            {
                key: 2,
                label: "sql",
            },
        ];
        this.cardColData = [];
        this.cardRowData = [];
        this.idToRippleName = {};
        this.rippleRowData = [];
        this.rippleHandlers = [];
        this.selectedRowIndex = -1;
        this.selectedRowId = -1;
        this.activeRipple = null;
        this.rippleManager = null;
        this.alertManager = null;
        this.nameToRippleId = null;
        this.rippleName = "";
        this.data = "";

        this.rippleManager = new RippleManager();
    }
    changeOpenDialogFlag = (flag) => {
        this.setState({ showAlertDialog: flag });
    };
    showAlertView = (title, body) => {
        this.setState({
            showAlertDialog: true,
            alertDialogMessage: body,
            alertDialogTitle: title,
        });
    };
    componentDidUpdate() {
        if (this.state.redirectToRipple) {
            this.props.setChipArray([]);
            this.props.setActiveRipple(this.props.activeRipple);
            this.closeModal();
            this.props.setChatRippleMsg("");
            this.props.setActivePage("Ripple");
        }
    }
    componentDidMount() {
        Mixpanel.callPageViewEvent("Ripple Log");
        this.title = "Ripple A";
        this.headCells = [
            {
                id: "Action",
                numeric: true,
                disablePadding: true,
                width: 60,
                label: "",
                align: "center",
            },
            {
                id: "Type",
                numeric: true,
                disablePadding: true,
                width: 30,
                label: "Type",
                align: "left",
            },
            {
                id: "name",
                numeric: false,
                disablePadding: true,
                width: 180,
                label: "Name",
                align: "left",
            },
            {
                id: "space",
                numeric: true,
                disablePadding: true,
                width: 180,
                label: "Location",
                align: "left",
            },
            {
                id: "createdDate",
                numeric: true,
                disablePadding: true,
                width: 80,
                label: "Created Date",
                align: "center",
            },
            {
                id: "addedToSpaceDate",
                numeric: true,
                disablePadding: true,
                width: 90,
                label: "Added To Space",
                align: "center",
            },
        ];
        this.setState({ chipsArray: this.chipsArray });
        this.generateRippleLogRowData();
    }

    generateRippleLogRowData = () => {
        this.setState({ showLoder: true });
        this.rippleManager = new RippleManager();
        this.rippleManager
            .loadRippleLog()
            .then((resp) => {
                this.setState({ logRowsData: resp });
                this.sortDataByExistingState();
                this.setState({ selectedRowIndex: -1 });

                this.setState({
                    showLoder: false,
                });
            })
            .catch((err) => {
                this.showAlertView("", err.error);
                this.setState({ showLoder: false });
            });
    };
    handleUpdateRippleName = (updatedRippleName) => {
        this.closeModal();
        this.setState({ showLoder: true });
        let selectedRowData = this.state.logRowsData[this.selectedRowIndex];
        let data = {
            rippleRegistryId: selectedRowData.rippleId,
            rippleName: updatedRippleName,
        };

        this.rippleManager
            .updateRippleName(data)
            .then((resp) => {
                if (this.state.sortedByDate === "createdOn") {
                    this.setState({
                        logRowsData: resp,
                        selectedRowIndex: -1,
                        isRowSelected: false,
                    });

                    this.sortDataByExistingState();
                    this.setState({ showLoder: false });
                } else {
                    var updatedRow = resp.filter(function (resp) {
                        return resp.rippleId == data.rippleRegistryId;
                    });

                    let rowsData = this.state.logRowsData;
                    var index = rowsData.findIndex(function (rowsData) {
                        return rowsData.rippleId == updatedRow[0].rippleId;
                    });
                    this.setState({
                        selectedRowIndex: -1,
                        isRowSelected: false,
                    });
                    this.state.logRowsData[index] = updatedRow[0];
                    this.setState({ showLoder: false });
                }
            })
            .catch((err) => {
                this.showAlertView("", err.error);
                this.setState({ showLoder: false });
            });
    };
    sortDataByExistingState = () => {
        this.state.logRowsData.sort((a, b) => {
            return (
                new Date(b.createdOn).getTime() -
                new Date(a.createdOn).getTime()
            );
        });
    };
    sortDataByDate = (sortType) => {
        if (sortType === "assending") {
            this.state.logRowsData.sort((a, b) => {
                return (
                    new Date(a.updatedOn).getTime() -
                    new Date(b.updatedOn).getTime()
                );
            });
            // this.setState({ logRowsData: rawData });
        } else if (sortType === "descending") {
            this.state.logRowsData.sort((a, b) => {
                return (
                    new Date(b.updatedOn).getTime() -
                    new Date(a.updatedOn).getTime()
                );
            });
            // this.setState({ logRowsData: rawData });
        }
    };

    handleSortActions = (actionType) => {
        if (actionType === "date") {
            if (this.state.sortBy === "assending") {
                this.sortDataByDate("descending");
                this.setState({
                    sortBy: "descending",
                    sortedByDate: "updatedOn",
                    selectedRowIndex: -1,
                    isRowSelected: false,
                });
            } else if (this.state.sortBy === "descending") {
                this.sortDataByDate("assending");
                this.setState({
                    sortBy: "assending",
                    sortedByDate: "updatedOn",
                    selectedRowIndex: -1,
                    isRowSelected: false,
                });
            }
        }
    };
    showRipplenameModal = () => {
        this.setState({ showRippleNameModal: true });
    };
    renderCardRow = () => {
        if (this.state.logRowsData) {
            if (this.state.logRowsData.length)
                return (
                    <RippleLogView
                        rowItems={this.state.logRowsData}
                        selectedIndex={this.state.selectedRowIndex}
                        handleRowSelected={this.handleRowSelected}
                        viewBtnCliked={this.handleViewBtnClick}
                        handlePageChange={this.handlePageChange}
                    ></RippleLogView>
                );
            else if (!this.state.showLoder) return <EmptyRipple></EmptyRipple>;
        }
    };
    renderHeader = () => {
        // if (this.state.isRowSelected === true) {
        return (
            <RippleLogHeaderView
                loadLog={this.generateRippleLogRowData}
                registryId={this.state.logRowsData[this.selectedRowIndex]}
                showData={this.state.logRowsData}
                selectedIndex={this.state.selectedRowIndex}
                removeHeader={this.removeHeader}
                showActions={this.state.isRowSelected}
                sortBtnClicked={this.handleSortActions}
                shareBtnClicked={this.handleShareBtnClick}
                linkBtnClicked={this.handleLinkBtnClick}
                recureBtnClicked={this.handleRecureBtnClick}
                editRippleBtnClicked={this.showRipplenameModal}
            ></RippleLogHeaderView>
        );
        // }
    };
    renderRippleNameModal = () => {
        if (this.state.showRippleNameModal === true) {
            return (
                <EditRippleNameModal
                    rippleName={this.rippleName}
                    updateRippleName={this.handleUpdateRippleName}
                    open={this.state.showRippleNameModal}
                    closeModal={this.closeModal}
                    rippledList={this.state.logRowsData}
                ></EditRippleNameModal>
            );
        }
    };
    renderShareDataModal = () => {
        return (
            <RippleLogShareModal
                open={this.state.showShareModal}
                closeModal={this.closeModal}
                handleShareBtnClickInModal={this.handleShareBtnClickInModal}
            ></RippleLogShareModal>
        );
    };
    renderLinkDataModal = () => {
        // modal for link to alert
        if (this.state.showLinkToAlertModal === true) {
            return (
                <RippleLogLinkModal
                    open={this.state.showLinkToAlertModal}
                    closeModal={this.closeModal}
                    handleLinkBtnClickInModal={this.handleLinkToAlertClick}
                ></RippleLogLinkModal>
            );
        }
    };
    renderLinkToSpaceDataModal = () => {
        // modal for link to alert
        if (this.state.showLinkToSpaceModal === true) {
            return (
                <RippleLogLinkToSpaceModal
                    open={this.state.showLinkToSpaceModal}
                    closeModal={this.closeModal}
                    handleLinkBtnClickInModal={this.handleLinkToAlertClick}
                ></RippleLogLinkToSpaceModal>
            );
        }
    };
    handleRecureBtnClick = (index) => {
        // this.selectedRowIndex = index;
        this.setState({ showRecureModal: true });
    };
    renderRecureModal = () => {
        if (this.state.showRecureModal === true) {
            let recureStr = "";

            if (this.state.logRowsData[this.selectedRowIndex] !== undefined) {
                if (
                    this.state.logRowsData[this.selectedRowIndex]
                        .rippleRecur !== "" &&
                    this.state.logRowsData[this.selectedRowIndex]
                        .rippleRecur !== "0"
                ) {
                    recureStr =
                        this.state.logRowsData[this.selectedRowIndex]
                            .rippleRecur;
                    this.data = recureStr;
                }
            }

            return (
                <RecureModalView
                    data={recureStr}
                    show={this.state.showRecureModal}
                    onHide={this.closeModal}
                    handleDisableRipple={this.handleDisableRipple}
                    onclick={this.closeModal}
                    onSubmit={this.handleRecureModalSubmit}
                ></RecureModalView>
            );
        }
    };
    parseDateExcelToUTC = (dateValue) => {
        let strDate = "" + dateValue;
        let localDate = getJsDateFromExcel(dateValue).toLocaleDateString(
            "en-US",
            {
                timeZone: "UTC",
            }
        );
        let time = getJsDateFromExcel(dateValue).toLocaleTimeString("en-US", {
            timeZone: "UTC",
            timeSyle: "short",
        });
        let temp = time.split(" ")[0].split(":");
        temp = temp[0] + ":" + temp[1] + " " + time.split(" ")[1];
        return localDate + " - " + temp;
    };

    getRecureValueByRippleId = (id) => {
        let temp = "";
        for (let index = 0; index < this.rippleRowData.length; index++) {
            let item = this.rippleRowData[index];
            if (item.rowId === parseInt(id)) {
                temp = item.stringValue[1];
                break;
            }
        }
        // this.rippleRowData.forEach((item) => {
        //     if (item.rowId === parseInt(id)) {
        //         temp = item.stringValue[0];
        //         break;
        //     }
        // });
        return temp;
    };
    getRippleNameById = (id) => {
        return this.idToRippleName[id];
    };
    getRippleIdByName = (name) => {
        return this.nameToRippleId[name];
    };

    // handleShowHistoryBtnClick = (flag) => {
    //     // this.state.showHistory === false
    //     //     ? this.setState({ showHistory: true })
    //     //     : this.setState({ showHistory: false });
    //     this.setState({ showHistory: flag });
    // };
    renderTitle = () => {
        return (
            <TitleBar
                username={this.props.username}
                title={"Ripple Log"}
            ></TitleBar>
        );
    };
    handleBackBtnClick = (event) => {};
    handleViewTableRowClick = (e, index) => {};
    handleViewInRippleClick = () => {
        this.setState({ redirectToRipple: true });
    };
    handleDeleteChipItem = (chipToDelete) => {
        let items = this.chipsArray;
        items.splice(chipToDelete.key, 1);
        this.setState({ chipsArray: items });
    };
    generateRippledChips = (searchWord) => {
        this.chipsArray = [];
        if (
            searchWord !== undefined &&
            searchWord !== null &&
            searchWord !== ""
        ) {
            let chipsArray = searchWord.split("&");
            chipsArray.forEach((word, index) => {
                this.chipsArray.push({ key: index, label: word });
            });
        }
    };
    onClickRippleChip = (text) => {};
    renderViewDocumentVieverModal = (event) => {
        // document Viewer component to show documents
        return (
            <DocViwer
                docName={this.state.currentShowFileName}
                fileLocation={this.state.currentShowFileLocation}
            ></DocViwer>
        );
    };
    showDocModalView = (event, index, fileName, row) => {
        http.sendRestRequest(
            `document/documentDetail?documentId=${row.documentId}`
        )
            .then((response) => {
                this.setState({
                    showDocModal: true,
                    currentShowFileName: fileName,
                });
                const fileType = response.documentName.split(".").pop();
                if (fileType === "pdf") {
                    setTimeout(() => {
                        this.setState({
                            currentShowFileLocation: response,
                        });
                    }, 1);
                } else {
                    this.setState({
                        currentShowFileLocation: response,
                    });
                }
            })
            .catch((error) => {
                this.showAlertView("", error.error);
                console.log(error);
            });
    };
    renderDocumentViever = () => {
        return (
            <DocumentViewerModal
                showHeader={true}
                footer="false"
                show={this.state.showDocModal}
                documentId={this.state.currentShowFileLocation.documentId}
                size="lg"
                onHide={this.closeDocViever}
                title=""
                onclick={() => {}}
                headerTitle={this.state.currentShowFileName}
                submitButtonText="Close"
                fileSource={this.state.currentShowFileLocation}
            >
                {this.renderViewDocumentVieverModal()}
            </DocumentViewerModal>
        );
    };
    renderViewDocumentModal = () => {
        if (
            this.state.logRowsData.length > 0 &&
            this.selectedRowIndex !== -1 &&
            this.state.logRowsData[this.selectedRowIndex] !== undefined
        ) {
            let data = this.state.logRowsData[this.selectedRowIndex];

            this.generateRippledChips(data.searchCriteria);
            this.props.setActiveRipple(data);

            return (
                <div className="container">
                    <div
                        className="row w-100"
                        style={{
                            justifyContent: "space-between",
                        }}
                    >
                        <span
                            className="mainTitle textEllipsis mb-3"
                            style={{ marginLeft: "19px", marginTop: "-27px" }}
                        >
                            {data.rippleName === "" ||
                            data.rippleName === "Name Ripple"
                                ? "Unsaved Ripple"
                                : data.rippleName}
                        </span>
                        {/* <span onClick={this.closeModal}>X</span> */}
                    </div>
                    <div className="row w-100">
                        <div className="col-8">
                            <ChipsView
                                items={this.chipsArray}
                                onclick={this.onClickRippleChip}
                            ></ChipsView>
                        </div>
                        <div
                            className="col-4"
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                            }}
                        >
                            <button
                                class="btn btnLabel doCenter newFontMontserrat"
                                id="viewInRippleModelBtn"
                                title="VIEW IN RIPPLE"
                                onClick={this.handleViewInRippleClick}
                            >
                                VIEW IN RIPPLE
                            </button>
                        </div>
                    </div>
                    <RippleLogTableView
                        title={this.title}
                        rows={this.viewModalData}
                        showModal={this.state.showViewModal}
                        columns={this.headCells}
                        showDocModalView={this.showDocModalView}
                        handleClick={(e, index) => {
                            this.handleViewTableRowClick(e, index);
                        }}
                    ></RippleLogTableView>
                </div>
            );
        } else {
            return null;
        }
    };
    closeModal = () => {
        this.setState({
            showViewModal: false,
            showLinkToAlertModal: false,
            showLinkToSpaceModal: false,
            showRecureModal: false,
            showShareModal: false,
            alertInfoModal: false,
            showRippleNameModal: false,
        });
    };
    closeDocViever = () => {
        this.setState({
            showDocModal: false,
            // currentShowFileLocation: "",
        });
    };
    renderViewDataModal = () => {
        return (
            <ModalView
                showHeader="false"
                footer="false"
                show={this.state.showViewModal}
                size="xl"
                onHide={this.closeModal}
                title=""
                // onclick={this.closeModal}
                submitButtonText="Close"
            >
                {this.renderViewDocumentModal()}
            </ModalView>
        );
    };
    handleLinkToAlertClick = () => {
        this.setState({ showLoder: true });
        let rowData = [];
        if (this.state.logRowsData.length > 0 && this.selectedRowIndex !== -1) {
            let data = this.state.logRowsData[this.selectedRowIndex];
            let alertBody = "Recur : " + data.recure + " Data : " + data.date;
            rowData.push(data.name);
            rowData.push(-1);
            rowData.push("ripple");
            rowData.push("true");
            rowData.push(alertBody);
            this.closeModal();
        }
    };

    handleLinkToSpaceClick = () => {};

    setFromText = (value, id, event) => {
        switch (id) {
            case "username":
                {
                    this.usename = value;
                }
                break;
            case "rippleName":
                {
                    this.rippleName = value;
                }
                break;
            default:
                break;
        }
    };
    handleShareBtnClickInModal = () => {};
    formatTimeForRecure = (timeString) => {
        let aa = timeString.split(" ")[1];
        let dateArray = timeString.split(" ")[0].split(":");
        let hh = aa === "PM" ? parseInt(dateArray[0]) + 12 : dateArray[0];
        let mm = dateArray[1];
        let ss = "00";
        return "" + hh + ":" + mm + ":" + ss;
    };
    formatDaysString = (dateObj) => {};
    handleDisableRipple = (enableId) => {};

    handleRecureModalSubmit = (
        selectedEvery,
        selectedWeek,
        selectedTime,
        dateObj,
        isClick,
        enableId
    ) => {
        this.closeModal();
        this.setState({ showLoder: true });
        let recureStr = "";
        let recureStrNew = "";
        let daysArray = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
        daysArray.forEach((day) => {
            if (dateObj[day]) {
                recureStrNew += day.toLocaleUpperCase() + ",";
            }
        });
        if (!recureStrNew) recureStrNew = "MON,TUE,WED,THU,FRI,SAT,SUN";
        else recureStrNew = recureStrNew.slice(0, -1);
        recureStrNew += "|" + selectedTime;
        recureStr = selectedTime;
        let selectedRowData = this.state.logRowsData[this.selectedRowIndex];
        let data = {
            rippleRegistryId: selectedRowData.rippleId,
            rippleRecur: recureStrNew,
        };

        this.rippleManager
            .updateRippleName(data)
            .then((resp) => {
                if (this.state.sortedByDate === "createdOn") {
                    this.setState({
                        logRowsData: resp,
                        selectedRowIndex: -1,
                        isRowSelected: false,
                    });
                    this.sortDataByExistingState();
                    this.setState({ showLoder: false });
                } else {
                    var updatedRow = resp.filter(function (resp) {
                        return resp.rippleId == data.rippleRegistryId;
                    });

                    let rowsData = this.state.logRowsData;
                    var index = rowsData.findIndex(function (rowsData) {
                        return rowsData.rippleId == updatedRow[0].rippleId;
                    });

                    this.state.logRowsData[index] = updatedRow[0];
                    this.setState({ showLoder: false });
                }
            })
            .catch((err) => {
                this.showAlertView("", err.error);
                this.setState({ showLoder: false });
            });
        if (isClick === true) {
            let disabled = -1;
            if (this.data.split("|")[0] === "DISABLE") {
                disabled = 1;
            } else {
                disabled = 0;
            }
            this.closeModal();

            this.setState({ showLoder: true });
            let selectedRowData = this.state.logRowsData[this.selectedRowIndex];

            let data = {
                rippleRegistryId: selectedRowData.rippleId,
            };

            http.sendRestRequest(
                `ripple/recur?rippleRegistryId=${data.rippleRegistryId}&isRecurEnabled=${disabled}`,
                "PUT"
            )
                .then((response) => {
                    this.generateRippleLogRowData();
                })
                .catch((error) => {
                    this.showAlertView("", error.error);
                    console.log(error);
                });
        }
    };

    getDocumentNameByRemovedTimestamp = (fileName) => {
        let tempDocumentName = fileName.split("_");
        let documentName = "";
        if (tempDocumentName.length > 1) {
            for (let index = 0; index < tempDocumentName.length - 1; index++) {
                documentName = documentName + tempDocumentName[index];
            }
            return documentName;
        } else {
            return fileName;
        }
    };
    generateViewRawData = () => {
        let rawData = [];
        if (this.rippleViewData !== null && this.rippleViewData !== undefined) {
            this.rippleViewData.forEach((documentItem) => {
                let fileName = documentItem.docName;
                let docType = fileName.split(".").pop();
                let tempRawData = {
                    type: docType,
                    name: fileName,
                    documentName: fileName,
                    documentId: documentItem.documentId,
                    Sapce: documentItem.spaceName,
                    location: documentItem.location,
                    createdDate: documentItem.createdOn,
                    addedToSpace: documentItem.createdOn,
                    btn: "View",
                };
                rawData.push(tempRawData);
            });
        }
        return Promise.all(rawData);
    };
    handleViewBtnClick = (index) => {
        this.setState({ showLoder: true });
        this.selectedRowIndex = index;
        // this.setState({ showViewModal: true, showLoder: false });
        let rippleHandler = new Ripple();
        rippleHandler.setRippleData(this.state.logRowsData[index]);
        let docArray = rippleHandler.getRippleDocumentsIdList();
        if (docArray !== null) {
            rippleHandler
                .getDocuments(docArray)
                .then((documentObjects) => {
                    this.rippleViewData = documentObjects;
                    this.generateViewRawData()
                        .then((rawResponse) => {
                            this.viewModalData = rawResponse;

                            this.setState({
                                showViewModal: true,
                                showLoder: false,
                            });
                        })
                        .catch((err) => {
                            this.showAlertView("", err.error);
                            this.setState({ showLoder: false });
                        });
                })
                .catch((err) => {
                    this.showAlertView("", err.error);
                    this.setState({ showLoder: false });
                });
        } else {
            this.rippleViewData = [];
            this.generateViewRawData().then((rawResponse) => {
                this.viewModalData = rawResponse;
                this.setState({
                    showViewModal: true,
                    showLoder: false,
                });
            });
        }
    };
    removeHeader = () => {
        this.setState({ isRowSelected: false });
    };
    handleRowSelected = (index) => {
        this.selectedRowIndex = index;
        let selectedRowData = this.state.logRowsData[this.selectedRowIndex];

        this.selectedRowId = selectedRowData.rippleId;
        this.rippleName = selectedRowData.rippleName;
        this.setState({ isRowSelected: true, selectedRowIndex: index });
    };

    handlePageChange = () => {
        this.setState({ isRowSelected: false, selectedRowIndex: -1 });
    };
    handleShareBtnClick = (index) => {
        // this.selectedRowIndex = index;
        this.setState({ showShareModal: true });
    };

    handleLinkBtnClick = (type) => {
        // this.selectedRowIndex = index;
        if (type === "toAlert") {
            this.setState({ showLinkToAlertModal: true });
        } else {
            this.setState({ showLinkToSpaceModal: true });
        }
    };
    render() {
        this.alertManager = this.props.alertManager;
        return (
            <>
                <div className="w-100 pl-0 pr-0 contentPaneBottom">
                    {this.state.logRowsData && this.state.logRowsData.length ? (
                        this.renderHeader()
                    ) : (
                        <div
                            class="rippleLog_header"
                            style={{ height: "10%" }}
                        ></div>
                    )}
                    {this.renderCardRow()}
                    {this.renderViewDataModal()}
                    {this.renderLinkDataModal()}
                    {this.renderLinkToSpaceDataModal()}
                    {this.renderShareDataModal()}
                    {this.renderRecureModal()}
                    {this.renderDocumentViever()}
                    {this.renderRippleNameModal()}
                    {/* {this.renderRippleNameModal()} */}
                </div>
                <Loader show={this.state.showLoder} />
                <AlertDialog
                    open={this.state.showAlertDialog}
                    message={this.state.alertDialogMessage}
                    title={this.state.alertDialogTitle}
                    isAlert={this.state.isAlert}
                    setOpen={this.changeOpenDialogFlag}
                ></AlertDialog>
                {this.state.redirectToRipple ? (
                    <Navigate
                        to={`${
                            this.basePathName ? "/" + this.basePathName : ""
                        }/ripple`}
                        replace={true}
                    />
                ) : null}
            </>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        setActiveRipple,
        setChatRippleMsg,
        setActivePage,
        setPageType,
        setWorkspaceManager,
        setAlertData,
        setAlertsWidget,
        setAlertManager,
        setCollabInfo,
        setChipArray,
    };
};

const mapStateToProps = (state) => {
    return {
        collabInfo: state.collabInfo,
        activeRipple: state.activeRipple,
        alertManager: state.alertManager,
        chipsArray: state.chipsArray,
        cuboidInfoByName: state.cuboidInfoByName,
    };
};
export default connect(mapStateToProps, mapDispatchToProps())(RippleLog);
